import apiService from './apiService';

export const getBPSSchedule = async () => {
    try {
        const response = await apiService.get('/api/Configuration/bps-schedule');
        return {
            ...response,
            startTime: response.startTime.substring(0, 5),
            endTime: response.endTime.substring(0, 5)
        };
    } catch (error) {
        console.error('Error fetching BPS schedule:', error);
        throw error;
    }
};

export const setBPSSchedule = async (schedule) => {
    try {
        // Convertir el formato de tiempo a TimeSpan
        const formattedSchedule = {
            ...schedule,
            startTime: `${schedule.startTime}:00`,  // Agregando segundos
            endTime: `${schedule.endTime}:00`       // Agregando segundos
        };
        
        const response = await apiService.post('/api/Configuration/bps-schedule', formattedSchedule);
        return response;
    } catch (error) {
        console.error('Error saving BPS schedule:', error);
        throw error;
    }
};

export const getSpeed = async () => {
    try {
        const response = await apiService.get('/api/Configuration/speed');
        return response;
    } catch (error) {
        console.error('Error fetching speed:', error);
        throw error;
    }
};

export const setSpeed = async (speed) => {
    try {
        const response = await apiService.post('/api/Configuration/speed', { speed });
        return response;
    } catch (error) {
        console.error('Error saving speed:', error);
        throw error;
    }
}; 